export const NOTIFICATIONS_PENDING = 'NOTIFICATIONS_PENDING';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const NOTIFICATIONS_REJECTED = 'NOTIFICATIONS_REJECTED';
export const READ_NOTIFICATIONS='READ_NOTIFICATIONS';